interface MapSectionProps {
  selectedShop: number | null;
  onShopSelect: (id: number | null) => void;
}

export default function MapSection({ selectedShop, onShopSelect }: MapSectionProps) {
  const shops = [
    { id: 1, name: '다움네일살롱', lat: 37.4979, lng: 127.0276, isPartner: true, type: '네일' },
    { id: 2, name: '라벤더 아이래쉬', lat: 37.5563, lng: 126.9236, isPartner: true, type: '속눈썹' },
    { id: 3, name: '로즈 스킨케어', lat: 37.5273, lng: 127.0381, isPartner: true, type: '피부관리' },
    { id: 4, name: '블룸 왁싱 스튜디오', lat: 37.5204, lng: 127.0233, isPartner: true, type: '왁싱' },
    { id: 5, name: '페탈 헤어살롱', lat: 37.5244, lng: 127.0472, isPartner: true, type: '헤어' },
    { id: 6, name: '오로라 메이크업', lat: 37.5194, lng: 127.0227, isPartner: true, type: '메이크업' },
    { id: 7, name: '뷰티플 네일', lat: 37.5012, lng: 127.0396, isPartner: false, type: '네일' },
    { id: 8, name: '엘레강스 스파', lat: 37.5145, lng: 127.0201, isPartner: false, type: '피부관리' },
    { id: 9, name: '샤인 래쉬', lat: 37.5321, lng: 127.0245, isPartner: false, type: '속눈썹' },
    { id: 10, name: '글로우 살롱', lat: 37.5089, lng: 127.0312, isPartner: false, type: '헤어' }
  ];

  return (
    <div className="mb-12">
      <div className="bg-white rounded-3xl overflow-hidden shadow-lg">
        <div className="relative w-full h-[500px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50625.88443396369!2d126.9783882!3d37.5172363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca28b61c565cd%3A0x858aedb4e4ea83eb!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDqsJXroojrjIDroZwgNDEz!5e0!3m2!1sko!2skr!4v1234567890123!5m2!1sko!2skr"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="주변 뷰티샵 지도"
          ></iframe>

          <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-lg max-w-xs">
            <div className="flex items-center space-x-4 mb-3">
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 rounded-full bg-gradient-to-br from-rose-400 to-pink-500 flex items-center justify-center shadow-md">
                  <i className="ri-star-fill text-white text-xs"></i>
                </div>
                <span className="text-sm font-medium text-gray-800">제휴 뷰티샵</span>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center">
                  <i className="ri-map-pin-fill text-white text-xs"></i>
                </div>
                <span className="text-sm font-medium text-gray-600">일반 뷰티샵</span>
              </div>
            </div>
          </div>

          <div className="absolute bottom-6 left-6 right-6">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-4 shadow-lg">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-500 rounded-full">
                  <i className="ri-search-line text-white text-lg"></i>
                </div>
                <input
                  type="text"
                  placeholder="지역, 샵 이름으로 검색하세요"
                  className="flex-1 bg-transparent text-sm text-gray-800 placeholder-gray-500 outline-none"
                />
                <button className="px-4 py-2 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-sm font-medium rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                  검색
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="p-6 border-t border-gray-100">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-medium text-gray-800">지도에서 찾은 뷰티샵</h3>
            <span className="text-sm text-gray-600">{shops.length}개 샵</span>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
            {shops.slice(0, 10).map((shop) => (
              <button
                key={shop.id}
                onClick={() => onShopSelect(shop.id === selectedShop ? null : shop.id)}
                className={`p-3 rounded-xl border-2 transition-all cursor-pointer ${
                  selectedShop === shop.id
                    ? 'border-rose-400 bg-rose-50'
                    : 'border-gray-200 hover:border-rose-300 bg-white'
                }`}
              >
                <div className="flex items-center space-x-2 mb-2">
                  {shop.isPartner ? (
                    <div className="w-5 h-5 rounded-full bg-gradient-to-br from-rose-400 to-pink-500 flex items-center justify-center">
                      <i className="ri-star-fill text-white text-xs"></i>
                    </div>
                  ) : (
                    <div className="w-5 h-5 rounded-full bg-gray-300 flex items-center justify-center">
                      <i className="ri-map-pin-fill text-white text-xs"></i>
                    </div>
                  )}
                  <span className="text-xs text-gray-500">{shop.type}</span>
                </div>
                <p className="text-sm font-medium text-gray-800 text-left truncate">{shop.name}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
